export default __webpack_public_path__ + "img/PPR0001023_1colored.55ddb552.png";